import { render } from "./CustomerImagesPage.vue?vue&type=template&id=0f74e842&scoped=true"
import script from "./CustomerImagesPage.vue?vue&type=script&lang=js"
export * from "./CustomerImagesPage.vue?vue&type=script&lang=js"

import "./CustomerImagesPage.vue?vue&type=style&index=0&id=0f74e842&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f74e842"]])

export default __exports__